export const filterInitialState = {
    tags: {
        label: 'Tag',
        value: []
    },
    seriale: {
        label: 'Seriale',
        isSensitive: true,
        value: ""
    },
    numeroDiTelefono: {
        label: 'Numero di telefono',
        isSensitive: true,
        value: ""
    },
    piano: {
        label: "Piano",
        isSensitive: true,
        value: ""
    },
    tipologiaSim: {
        label: "Tipologia",
        value: ""
    },
    collaborators: {
        label: "Collaboratore",
        value: []
    }
}

export const sortingCriteria =
    [
        {text: "Numero di telefono", value: "numeroDiTelefono"},
        {text: "Seriale", value: "seriale"},
        {text: "Piano", value: "piano"}
    ]

export const filterRadioButtons =
    [
        {text: "Numero di telefono", value: "numeroDiTelefono"},
        {text: "Numero seriale", value: "seriale"},
        {text: "Tag", value: "tags"}
    ]
export const headCells = [
    {id: 'Numero di telefono', label: 'Numero di telefono', width: "20%"},
    {id: 'Seriale', label: 'Seriale', width: "20%"},
    {id: 'Piano', label: "Piano", width: "15%"},
    {id: 'tags', label: '', width: "30%"},
    {id: 'wrench', label: '', width: "15%"}
]
